<template>
    <div>
        <div v-if="edit" class="item add" @click="toggleAdd()">{{ $t('user.favorites.btn')}}</div>
        <div v-if="edit && add" class="item">
            <input v-model="input" :placeholder="$t('user.favorites.category_name_text')" @keyup.enter="addItem()" @blur="addItem()"/>
        </div>
        <div v-for="category in categories" :key="category.id" class="item" @click="editInput(category.id, category.title)">
            <input :ref="'inputcategory' + category.id" v-model="input" :placeholder="$t('user.favorites.category_name_text')" @keyup.enter="editItem(category.id)" @blur="editItem(category.id)" v-show="edit && inputShow == category.id" />
            <i v-if="edit && inputShow != category.id" class="icon-close" @click="deleteItem(category.id)"></i>
            <a :href="`/${$t('routes.profile')}/${$t('routes.user-favorites')}?category=` + category.id" v-if="!edit || inputShow != category.id">{{category.title}}</a>
        </div>
        <div class="item">
            <a :href="`/${$t('routes.profile')}/${$t('routes.user-favorites')}`">{{ $t('user.favorites.title')}}</a>
        </div>
        <div v-if="!edit" class="item edit" @click="toggleEdit()">{{ $t('user.favorites.edit_categories')}}</div>
        <div v-if="edit" class="item closeEdit" @click="toggleEdit()">{{ $t('user.favorites.end_edit_categories')}}</div>
    </div>
</template>

<script>
import Request from '@Core/xhr'
import forEach from '@Utils/forEach'

import { createNamespacedHelpers } from 'vuex'

export default {

    data() {
        return {
            categories: [],
            edit: false,
            add: false,
            inputShow: 0,
            input: ""
        }
    },

    computed: {
    },


    created() {
        new Request().get('/favorites/categories').then((response) => {
            this.categories = response;
        })
    },

    methods: {

        toggleEdit() {
            this.edit = this.edit ? false : true;
            if(!this.edit) {
                this.add = false;
            }
        },

        toggleAdd() {
            this.input = "";
            this.add = this.add ? false : true;
        },

        deleteItem(itemId) {
            let request = new Request({ id: itemId })
            request.post('/favorites/remove-category').then((response) => {
                this.categories = response;
            })
        },

        addItem() {
            if(this.input != "") {
                let request = new Request({ title: this.input })
                request.post('/favorites/add-category').then((response) => {
                    this.categories = response;
                })
                this.input = "";
            }
            
        },

        editInput(itemId, title) {
            this.input = title;
            this.inputShow = itemId;
            this.$nextTick(() => [...this.$refs['inputcategory' + itemId]].pop().focus());
        },

        editItem(itemId) {
            if(this.input != "") {
                let request = new Request({  id: itemId, title: this.input })
                request.post('/favorites/edit-category').then((response) => {
                    this.categories = response;
                })
                this.input = "";
                this.inputShow = 0;
            }
            
        }
    }

}
</script>
